module.exports = __webpack_public_path__ + "img/image6.de302203.png";